import * as AUTH_TYPES from '../store/entities/Auth/Auth.types'
import * as TYPES from "./entities/Profile/Profile.types";

export const onSuccess = (response, action, store) => {
  console.log('response', response);
 
  if (action.callback) {
    action.callback(response);
  }

  if (action.type === AUTH_TYPES.CREATE_SESSION && AUTH_TYPES.LOGOUT){
    store.dispatch({type: TYPES.ON_LOGOUT});
  }
  return response;
};

export const onError = (error, action) => {
  console.log('error', error);
  if (action.errorCallback) {
    action.errorCallback(error);
  }

  throw error;
};
